'use strict'

import update from 'immutability-helper';

import * as types from './types';
import * as lTypes from '@/state/domains/locationList/types';
import * as jTypes from '@/state/domains/orders/types';

export default (state = {}, action) => {

	let username, date, assignments, locations, partitions,
		index, dragIndex, hoverIndex, newLocations;

	switch (action.type) {

		case jTypes.POST_ASSIGN_JOBS_COMPLETED:

			({ username, date, assignments } = action.data);

			return {
				...state,
				[ username ]: {
					...state[ username ],
					[ date ]: assignments,
				},
			};

		case types.GET_ASSIGNMENTS_COMPLETED:

			({ assignments } = action.data);
			({ username } = action.meta.params);

			return {
				...state,
				[ username ]: {
					...state[ username ],
					...assignments,
				},
			};

		case types.REORDER_ASSIGNED:

			({ date, dragIndex, hoverIndex } = action.data);
			({ username } = action.meta.body);

			const loc = state[ username ][ date ].locations[ dragIndex ];

			return update(
				state,
				{
					[ username ]: {
						[ date ]: {
							locations: {
								$splice: [
									[ dragIndex, 1 ], [ hoverIndex, 0, loc ]
								],
							},
						},
					},
				}
			);

		/*case types.MOVE_SELECTION:

			({ date, selectedIdxs, direction } = action.data);
			({ username } = action.meta.body);

			const locations = state[ username ][ date ].locations;
			const numLocations = locations.length;
			const lastIdx = numLocations - 1;

			const newIdxs = selectedIdxs.map((el, i) => {

				if (direction > 0 && el === lastIdx) {
					return 0;
				} else if (direction < 0 && el === 0) {
					return lastIdx;
				}
				return el + direction;
			});

			const unSel = locations.filter((el, i) => selectedIdxs.indexOf(i) === -1);

			const reordered = locations.map((el, i) => {

				const idx = newIdxs.indexOf(i);

				return (idx === -1) ?
					unSel.shift() :
					locations[ selectedIdxs[ idx ] ];
			});

			return update(
				state,
				{
					[ username ]: {
						[ date ]: {
							locations: {
								$set: reordered,
							},
						},
					},
				}
			);*/

		case lTypes.POST_REVERSE_SELECTION_COMPLETED:
		case lTypes.POST_OPTIMIZE_ROUTE_COMPLETED:
		case lTypes.POST_DELETE_LOCATIONS_COMPLETED:

			({ date, username } = action.meta.body);
			({ assignments } = action.data);

			return update(
				state,
				{
					[ username ]: {
						[ date ]: {
							$set: assignments,
						},
					},
				}
			);

		case lTypes.POST_ASSIGN_NEXT_DAY_COMPLETED:

			({ username } = action.meta.body);
			({ date, assignments } = action.data);

			return update(
				state,
				{
					[ username ]: {
						[ date ]: {
							$set: assignments,
						},
					},
				}
			);

		case lTypes.POST_FLAG_INCREMENT_COMPLETED:

			({ username, date, index } = action.meta.body);

			newLocations = state[ username ][ date ].locations.slice(0);
			newLocations[ index ].flag = action.data.flagValue;

			return update(
				state,
				{
					[ username ]: {
						[ date ]: {
							locations: {
								$set: newLocations,
							},
						},
					},
				}
			);

		case lTypes.POST_FLAG_INCREMENT_COMPLETED:

			({ username, date, index } = action.meta.body);

			newLocations = state[ username ][ date ].locations.slice(0);
			newLocations[ index ].priority = action.data.priorityValue;

			return update(
				state,
				{
					[ username ]: {
						[ date ]: {
							locations: {
								$set: newLocations,
							},
						},
					},
				}
			);

		case lTypes.POST_ADD_TO_ROUTE_COMPLETED:
		case lTypes.POST_REORDERED_LOCATIONS_COMPLETED:

			({ date, username } = action.meta.params);
			({ assignments } = action.data);

			return update(
				state,
				{
					[ username ]: {
						[ date ]: {
							$set: assignments,
						},
					},
				}
			);

		default:
			return state;
	}
};
